import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-divider" />
        <div className="footer-main">
          <div className="footer-left">
            <span className="footer-logo">RentWise</span>
            <span className="footer-tagline">Built by renters, for renters.</span>
          </div>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/rentwiseapp.co"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="Instagram"
            >
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@rentwiseapp"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="TikTok"
            >
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.88-2.88 2.89 2.89 0 0 1 2.88-2.88c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.8a8.27 8.27 0 0 0 4.76 1.5V6.86a4.84 4.84 0 0 1-1-.17z"/>
              </svg>
            </a>
          </div>
        </div>
        <nav className="footer-legal" aria-label="Legal links">
          <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
        </nav>
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} RentWise. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
